'use client';

import { useState } from 'react';
import Link from 'next/link';
import { 
  ShieldCheck, ArrowRight, Menu, Phone, Mail, Linkedin, Instagram, Youtube,
  Building, Building2, Factory, Stethoscope, GraduationCap, ShoppingCart, 
  Briefcase, CheckCircle2, LayoutTemplate, Users, ShieldAlert, X, ChevronRight
} from 'lucide-react';

export default function ParaQuemEPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const wppLink = "https://wa.me/554888796761?text=Quero%20falar%20com%20um%20especialista%20sobre%20o%20sistema%20Nexus%20Safe.";
  const appLink = "https://app.nexussafe.com.br/";

  return (
    <div className="min-h-screen bg-white selection:bg-blue-200 selection:text-blue-900 font-sans text-gray-800 relative flex flex-col overflow-x-hidden">
      
      {/* ================= FIO LATERAL COLORIDO ================= */}
      <div className="hidden sm:block" style={{
        position: 'fixed', top: 0, left: '24px', width: '6px', height: '100vh',
        background: 'linear-gradient(to bottom, #06b6d4, #3b82f6, #8b5cf6, #ec4899)', 
        zIndex: 99999, boxShadow: '0 0 15px rgba(59, 130, 246, 0.4)'
      }}></div>

      {/* ================= NAVBAR ================= */}
      <nav className="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 shadow-sm top-0">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative">
          <div className="flex items-center shrink-0 h-full">
            <Link href="/" className="flex items-center">
              <img src="/logo-nexus.png" alt="NexusSafe" style={{ height: '40px', width: 'auto' }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if(fallback) fallback.style.display = 'flex';
                }}
              />
              <div style={{ display: 'none' }} className="items-center gap-2">
                <ShieldCheck size={28} className="text-gray-900" />
                <span className="text-xl font-black text-gray-900 tracking-tight">NEXUS<span className="font-light">SAFE</span></span>
              </div>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center gap-4 lg:gap-8 font-bold text-sm text-gray-600">
            <Link href="/site/solucoes" className="hover:text-blue-600 transition-colors">Soluções</Link>
            <Link href="/site/para-quem-e" className="text-blue-600 transition-colors">Para quem é</Link>
            <Link href="/site/recursos" className="hover:text-blue-600 transition-colors">Recursos</Link>
            <Link href="/site/conteudos" className="hover:text-blue-600 transition-colors">Conteúdos</Link>
            <Link href="/site/sobre-nos" className="hover:text-blue-600 transition-colors">Sobre nós</Link>
          </div>

          <div className="flex items-center gap-4 text-sm font-bold shrink-0">
            <div className="hidden md:flex items-center gap-4">
              <a href={appLink} className="text-gray-800 hover:text-blue-600 transition-colors border-r border-gray-300 pr-4">Entrar</a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-5 py-2.5 rounded-full hover:bg-blue-700 transition-all flex items-center gap-2 shadow-lg shadow-blue-600/20 whitespace-nowrap">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
            
            {/* Ícone Menu Mobile - Só aparece no celular (md:hidden) */}
            <button 
              className="md:hidden text-gray-800 p-2 transition-colors hover:text-blue-600"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Alternar menu"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* ================= MENU MOBILE (DROPDOWN) ================= */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 w-full bg-white shadow-xl border-t border-gray-100 flex flex-col p-6 gap-4 z-40 max-h-[calc(100vh-80px)] overflow-y-auto">
            <Link href="/site/solucoes" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Soluções <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/para-quem-e" onClick={() => setIsMobileMenuOpen(false)} className="text-blue-600 font-bold py-3 border-b border-gray-50 flex justify-between items-center">
              Para quem é <ChevronRight size={16} className="text-blue-400" />
            </Link>
            <Link href="/site/recursos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Recursos <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/conteudos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Conteúdos <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/sobre-nos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Sobre nós <ChevronRight size={16} className="text-gray-400" />
            </Link>
            
            <div className="flex flex-col gap-3 mt-4">
              <a href={appLink} className="w-full text-center text-gray-900 font-bold py-3.5 border-2 border-gray-200 rounded-full hover:bg-gray-50 transition-colors">
                Entrar no Sistema
              </a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="w-full bg-blue-600 text-white py-3.5 rounded-full font-bold hover:bg-blue-700 transition-all flex justify-center items-center gap-2 shadow-lg shadow-blue-600/20">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* ================= HERO SECTION ================= */}
      <section className="pt-40 pb-20 px-6 bg-gray-50 border-b border-gray-100">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <div className="text-blue-600 font-bold text-sm tracking-widest uppercase">Escalável e Adaptável</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-[1.1] tracking-tight">
            A tecnologia exata para o seu <span className="text-blue-600">tamanho e setor.</span>
          </h1>
          <p className="text-lg text-gray-500 font-medium leading-relaxed max-w-2xl mx-auto">
            Não importa se você tem 10 ou 10.000 funcionários. O NexusSafe é flexível para atender desde clínicas locais até gigantes da indústria e construção civil.
          </p>
        </div>
      </section>

      {/* ================= TAMANHO DAS EMPRESAS ================= */}
      <section className="py-24 px-6 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight mb-4">Para todas as escalas</h2>
          <p className="text-gray-500 font-medium">Desenvolvemos planos e módulos que crescem junto com o seu negócio.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-blue-500 transition-all group">
            <div className="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600 mb-6 group-hover:scale-110 transition-transform"><Building size={28} /></div>
            <h3 className="text-xl font-black text-gray-900 mb-3">Pequenas Empresas</h3>
            <p className="text-sm text-gray-500 font-medium mb-6">Pare de sofrer com planilhas de Excel e papéis perdidos. Digitalize sua entrega de EPI e aplique questionários rapidamente com excelente custo-benefício.</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-gray-700 font-bold"><CheckCircle2 size={16} className="text-green-500"/> Fim da papelada</li>
              <li className="flex items-center gap-2 text-sm text-gray-700 font-bold"><CheckCircle2 size={16} className="text-green-500"/> Gestão simplificada</li>
            </ul>
          </div>
          
          <div className="bg-white p-8 rounded-3xl border-2 border-blue-600 shadow-xl relative md:-translate-y-4">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">Mais comum</div>
            <div className="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600 mb-6"><Building2 size={28} /></div>
            <h3 className="text-xl font-black text-gray-900 mb-3">Médias Empresas</h3>
            <p className="text-sm text-gray-500 font-medium mb-6">Centralize toda a sua operação de SST. Organize CIPA, canais de denúncia anônimos, avaliações da NR-01 e evite multas com processos bem estruturados.</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-gray-700 font-bold"><CheckCircle2 size={16} className="text-blue-500"/> Centralização do GRO</li>
              <li className="flex items-center gap-2 text-sm text-gray-700 font-bold"><CheckCircle2 size={16} className="text-blue-500"/> Dashboards dinâmicos</li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-blue-500 transition-all group">
            <div className="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600 mb-6 group-hover:scale-110 transition-transform"><LayoutTemplate size={28} /></div>
            <h3 className="text-xl font-black text-gray-900 mb-3">Grandes Corporações</h3>
            <p className="text-sm text-gray-500 font-medium mb-6">Gerencie dezenas de filiais (Tenants), acompanhe planos de ação (PDCA) e integre milhares de colaboradores com segurança e permissões de acesso granulares.</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-gray-700 font-bold"><CheckCircle2 size={16} className="text-green-500"/> Multi-Filiais</li>
              <li className="flex items-center gap-2 text-sm text-gray-700 font-bold"><CheckCircle2 size={16} className="text-green-500"/> Permissões de Acesso</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= SEGMENTOS DE ATUAÇÃO ================= */}
      <section className="py-24 bg-gray-900 text-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <span className="text-blue-400 font-black uppercase tracking-widest text-xs mb-3 block">Segmentos</span>
            <h2 className="text-3xl md:text-4xl font-black tracking-tight mb-4">Em qualquer mercado, a segurança é prioridade</h2>
            <p className="text-gray-400 font-medium max-w-2xl mx-auto">Nossas ferramentas de diagnóstico e controle foram construídas considerando a complexidade das normas de diferentes indústrias.</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white/5 border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-colors">
              <Factory size={32} className="text-blue-400 mb-4" />
              <h4 className="text-lg font-bold mb-2">Indústria & Manufatura</h4>
              <p className="text-sm text-gray-400">Controle massivo de EPIs, Checklists de máquinas e monitoramento de riscos operacionais (PGR).</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-colors">
              <Building2 size={32} className="text-orange-400 mb-4" />
              <h4 className="text-lg font-bold mb-2">Construção Civil</h4>
              <p className="text-sm text-gray-400">Inspeções de campo diárias, gestão de empreiteiras e mobilidade para atuar direto nos canteiros de obra.</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-colors">
              <Stethoscope size={32} className="text-green-400 mb-4" />
              <h4 className="text-lg font-bold mb-2">Saúde & Clínicas</h4>
              <p className="text-sm text-gray-400">Atendimento aos rigorosos parâmetros da vigilância sanitária, riscos biológicos e estresse psicossocial.</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-colors">
              <Briefcase size={32} className="text-purple-400 mb-4" />
              <h4 className="text-lg font-bold mb-2">Serviços Corporativos</h4>
              <p className="text-sm text-gray-400">Foco em ergonomia, saúde mental, canais de denúncia para assédio e clima organizacional.</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-colors">
              <ShoppingCart size={32} className="text-yellow-400 mb-4" />
              <h4 className="text-lg font-bold mb-2">Varejo & Comércio</h4>
              <p className="text-sm text-gray-400">Redes de lojas com múltiplos GHEs, CIPA por estabelecimento e gestão ágil de treinamentos.</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-6 rounded-3xl hover:bg-white/10 transition-colors">
              <GraduationCap size={32} className="text-pink-400 mb-4" />
              <h4 className="text-lg font-bold mb-2">Educação</h4>
              <p className="text-sm text-gray-400">Gestão de campus, prevenção contra incêndio, planos de abandono e saúde vocal dos professores.</p>
            </div>
          </div>
        </div>
        <div className="absolute right-0 bottom-0 w-[800px] h-[800px] border-[80px] border-blue-600/10 rounded-full translate-x-1/3 translate-y-1/3 pointer-events-none"></div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer style={{ backgroundColor: '#020617', paddingTop: '100px', paddingBottom: '40px' }} className="font-medium mt-auto">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 border-b border-gray-800 pb-16">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center mb-6">
              <Link href="/" className="flex items-center">
                <img src="/logo-nexus-branca.png" alt="NexusSafe" style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const fallback = target.nextElementSibling as HTMLElement;
                    if(fallback) fallback.style.display = 'flex';
                  }}
                />
                <div style={{ display: 'none' }} className="items-center gap-2">
                  <ShieldCheck size={28} className="text-white" />
                  <span className="text-xl font-black text-white tracking-tight">NEXUSSAFE</span>
                </div>
              </Link>
            </div>
            <p style={{ color: '#9CA3AF' }} className="text-sm leading-relaxed mb-8">
              A plataforma inteligente que simplifica a gestão de Segurança e Saúde do Trabalho e conecta pessoas, dados e resultados.
            </p>
            <div className="flex gap-4">
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Linkedin size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Instagram size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Youtube size={18} /></a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Soluções</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Psicossocial + Plano</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Canal de Denúncia</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Checklist</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Plano de Ação</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Entrega de EPI</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Questionários</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">CIPA</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Para quem é</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Indústrias</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Construtoras</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Comércio</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Serviços</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Saúde</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Educação</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Recursos</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-8">
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Materiais</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Webinars</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Cases</Link></li>
            </ul>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Sobre Nós</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Institucional</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Parceiros</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Contato</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Fale Conosco</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-6">
              <li className="flex items-center gap-3"><Phone size={14} className="shrink-0"/> (48) 9.8879-6761</li>
              <li className="flex items-center gap-3"><Mail size={14} className="shrink-0"/> comercial@nexussafe.com.br</li>
            </ul>
            <a href={wppLink} target="_blank" rel="noopener noreferrer" className="inline-flex bg-blue-600 text-white px-5 py-2.5 rounded-full font-bold text-xs hover:bg-blue-700 transition-all items-center gap-2">
              Fale com um especialista <ArrowRight size={14} />
            </a>
          </div>
        </div>
        <div style={{ color: '#9CA3AF' }} className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p className="text-center md:text-left">© 2026 NexusSafe - Criado por Leandro Rodrigo de Oliveira - Todos os direitos reservados</p>
          <div className="flex items-center gap-6">
            <a href="https://nexussafe.com.br/site/privacidade" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Política de Privacidade</a>
            <a href="https://nexussafe.com.br/site/termos" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Termos de Uso</a>
          </div>
        </div>
      </footer>
    </div>
  );
}